import { Ledger } from "@common/contracts/ledger.contract";
import {
    AccountingLedgerBasis,
    BOTH_LEDGER_BASIS,
} from "@common/types/domains/accounting/ledger";
import { LedgerBasisOption } from "@components/ledger/LedgerBasisSelect";

/**
 * Offers the "All" selection that posts one journal entry to both ledgers.
 *
 * The backend resolves `cash_and_accrual` against the entity's *primary* cash
 * and accrual ledgers, so the option is only eligible when both of those exist.
 * A non-primary duplicate cannot satisfy it.
 */
export function buildBothLedgersOptions(
    ledgers: Ledger[],
): LedgerBasisOption[] {
    const hasPrimaryCashLedger = ledgers.some(
        (ledger) =>
            ledger.isPrimary && ledger.basis === AccountingLedgerBasis.cash,
    );
    const hasPrimaryAccrualLedger = ledgers.some(
        (ledger) =>
            ledger.isPrimary && ledger.basis === AccountingLedgerBasis.accruals,
    );

    if (!hasPrimaryCashLedger || !hasPrimaryAccrualLedger) {
        return [];
    }

    return [{ value: BOTH_LEDGER_BASIS, label: "All" }];
}
